import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';

@Injectable()
export class TenantInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<{}>,
    next: HttpHandler
  ): Observable<HttpEvent<{}>> {
    if (environment.envName === 'local') {
      const headers: HttpHeaders = new HttpHeaders({
        'X-Mojo-User-Name': 'italent',
        'X-Mojo-User-Id': '11',
        'X-Mojo-Tenant-Id': 'italent',
        'X-Mojo-Tenant-Name': 'italent'
      });
      request = request.clone({ headers });
    }
    return next.handle(request);
  }
}
